export default [
    {
        routeName: 'offerFlow-steps-twocol-date',
        name: 'offerFlow.pages.stepDate.name.common',
    },
    {
        routeName: 'offerFlow-steps-twocol-passengers',
        name: 'offerFlow.pages.stepPassengers.name.common',
        skipIfUpsell: true,
    },
    {
        routeName: 'offerFlow-steps-rental-location',
        name: 'offerFlow.pages.stepRentalLocation.name.common',
    },
    {
        routeName: 'offerFlow-steps-twocol-rental-equipment',
        name: 'offerFlow.pages.stepRentalEquipment.name.common',
    },

] as ProductFlowStep[];
